import { InjectionToken } from '@angular/core'
export interface IndexDBConfig {
  dbName: string
}

export const INDEXDB_CONFIG: InjectionToken<IndexDBConfig> = new InjectionToken<IndexDBConfig>('indexdb.config')
